export enum REQUEST_TYPES {
	HAS_TASK_TYPE_FUNCTIONALITY = 'GET_TASK_TYPE_TABLE_EXIST',
	GET_TASK_TYPE_ELEMENTS = 'GET_TASK_TYPE_ELEMENTS',
	GET_ALL_TASK_TYPE_ELEMENTS = 'GET_ALL_TASK_TYPE_ELEMENTS',
	GET_FILTERED_TASK_TYPE_ELEMENTS = 'GET_FILTERED_TASK_TYPE_ELEMENTS',
	DO_DELETE_TASK_TYPES = 'DO_DELETE_TASK_TYPE',
	UPDATE_TASK_TYPE = 'DO_UPDATE_TASK_TYPE_ELEMENT',
	CREATE_TASK_TYPE = 'DO_ADD_TASK_TYPE_ELEMENT',
}
